/**
 * 麵包屑對應表 (Route mapping)
 * @param {string} name 頁面名稱
 * @param {string} route 頁面 route name
 * @param {string} path 頁面 route path
 * @param {string} redirect 如沒實際頁面，直接導向的route name
 * @param {string} breadcrumb 頁面麵包屑
 * @param {string} parent 上一層頁面 route name
 * @param {string} showTab 頁面是否顯示Tab區塊
 */
export const BREADCRUMB_MAPPING = [
  {
    name: '首頁',
    route: 'Home',
    path: '/',
    breadcrumb: ['Home'],
    parent: 'Home',
    showTab: true,
    title: '社區總覽'
  },
  {
    name: '帳號設定',
    route: 'account-setting',
    path: '/account/setting',
    file: 'account/setting',
    breadcrumb: ['Home', 'account-setting'],
    parent: '',
    showTab: false
  },
  {
    name: '編輯帳號',
    route: 'account-setting-edit',
    path: '/account/setting/edit',
    file: 'account/edit',
    breadcrumb: ['Home', 'account-setting', 'account-setting-edit'],
    parent: '',
    showTab: false
  },
  {
    name: '社區服務管理',
    route: 'service',
    path: '/service',
    redirect: '/service/communityNotices',
    breadcrumb: ['Home', 'service'],
    showTab: false
  },
  {
    name: '郵件包裹',
    route: 'service-mailPackages',
    path: '/service/mailPackages',
    keepalive: 'MailPackages',
    breadcrumb: ['Home', 'service', 'service-mailPackages'],
    parent: 'service',
    showTab: true
  },
  {
    name: '郵件包裹通知',
    route: 'service-mailPackages-send',
    path: '/service/mailPackages/send',
    file: 'service/mailPackages/send',
    breadcrumb: [
      'Home',
      'service',
      'service-mailPackages',
      'service-mailPackages-send'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '新增收件',
    route: 'service-mailPackages-add',
    path: '/service/mailPackages/add',
    file: 'service/mailPackages/add',
    breadcrumb: [
      'Home',
      'service',
      'service-mailPackages',
      'service-mailPackages-add'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '編輯收件',
    route: 'service-mailPackages-edit',
    path: '/service/mailPackages/:id',
    file: 'service/mailPackages/edit',
    breadcrumb: [
      'Home',
      'service',
      'service-mailPackages',
      'service-mailPackages-edit'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '社區公告',
    route: 'service-communityNotices',
    path: '/service/communityNotices',
    keepalive: 'CommunityNotices',
    breadcrumb: ['Home', 'service', 'service-communityNotices'],
    parent: 'service',
    showTab: true
  },
  {
    name: '新增公告',
    route: 'service-communityNotices-add',
    path: '/service/communityNotices/add',
    file: 'service/communityNotices/add',
    breadcrumb: [
      'Home',
      'service',
      'service-communityNotices',
      'service-communityNotices-add'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '編輯公告',
    route: 'service-communityNotices-edit',
    path: '/service/communityNotices/:id',
    file: 'service/communityNotices/edit',
    breadcrumb: [
      'Home',
      'service',
      'service-communityNotices',
      'service-communityNotices-edit'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '繳費通知',
    route: 'service-paymentNotices',
    path: '/service/paymentNotices',
    keepalive: 'PaymentNotices',
    breadcrumb: ['Home', 'service', 'service-paymentNotices'],
    parent: 'service',
    showTab: true
  },
  {
    name: '新增通知',
    route: 'service-paymentNotices-add',
    path: '/service/paymentNotices/add',
    file: 'service/paymentNotices/add',
    breadcrumb: [
      'Home',
      'service',
      'service-paymentNotices',
      'service-paymentNotices-add'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '瓦斯登記',
    route: 'service-gasRegistration',
    path: '/service/gasRegistration',
    keepalive: 'GasRegistration',
    breadcrumb: ['Home', 'service', 'service-gasRegistration'],
    parent: 'service',
    showTab: true
  },
  {
    name: '新增登記項目',
    route: 'service-gasRegistration-add',
    path: '/service/gasRegistration/add',
    file: 'service/gasRegistration/add',
    breadcrumb: [
      'Home',
      'service',
      'service-gasRegistration',
      'service-gasRegistration-add'
    ],
    parent: '',
    showTab: false
  },
  {
    route: 'service-gasRegistration-register',
    path: '/service/gasRegistration/register',
    redirect: '/service/gasRegistration',
    breadcrumb: ['Home', 'service', 'service-gasRegistration'],
    parent: '',
    showTab: false
  },
  {
    name: '住戶登記列表',
    route: 'service-gasRegistration-register-id',
    path: '/service/gasRegistration/register/:id',
    file: 'service/gasRegistration/register',
    breadcrumb: [
      'Home',
      'service',
      'service-gasRegistration',
      'service-gasRegistration-register-id'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '編輯登記項目',
    route: 'service-gasRegistration-edit',
    path: '/service/gasRegistration/:id',
    file: 'service/gasRegistration/edit',
    breadcrumb: [
      'Home',
      'service',
      'service-gasRegistration',
      'service-gasRegistration-edit'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '公設資訊',
    route: 'service-publicFacilities',
    path: '/service/publicFacilities',
    keepalive: 'PublicFacilities',
    breadcrumb: ['Home', 'service', 'service-publicFacilities'],
    parent: 'service',
    showTab: true
  },
  {
    name: '新增公設',
    route: 'service-publicFacilities-add',
    path: '/service/publicFacilities/add',
    file: 'service/publicFacilities/edit',
    breadcrumb: [
      'Home',
      'service',
      'service-publicFacilities',
      'service-publicFacilities-add'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '編輯公設',
    route: 'service-publicFacilities-id',
    path: '/service/publicFacilities/:id',
    file: 'service/publicFacilities/edit',
    breadcrumb: [
      'Home',
      'service',
      'service-publicFacilities',
      'service-publicFacilities-id'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '服務聯繫',
    route: 'service-serviceContact',
    path: '/service/serviceContact',
    keepalive: 'ServiceContact',
    breadcrumb: ['Home', 'service', 'service-serviceContact'],
    parent: 'service',
    showTab: true
  },
  {
    name: '新增服務聯繫',
    route: 'service-serviceContact-add',
    path: '/service/serviceContact/add',
    file: 'service/serviceContact/edit',
    breadcrumb: [
      'Home',
      'service',
      'service-serviceContact',
      'service-serviceContact-add'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '編輯服務聯繫',
    route: 'service-serviceContact-id',
    path: '/service/serviceContact/:id',
    file: 'service/serviceContact/edit',
    breadcrumb: [
      'Home',
      'service',
      'service-serviceContact',
      'service-serviceContact-id'
    ],
    parent: '',
    showTab: false
  },
  // {
  //   name: '廣告管理',
  //   route: 'service-advertisementManagement',
  //   path: '/service/advertisementManagement',
  //   keepalive: 'AdvertisementManagement',
  //   breadcrumb: ['Home', 'service', 'service-advertisementManagement'],
  //   parent: 'service',
  //   showTab: true
  // },
  // {
  //   name: '新增廣告',
  //   route: 'service-advertisementManagement-add',
  //   path: '/service/advertisementManagement/add',
  //   file: 'service/advertisementManagement/edit',
  //   breadcrumb: [
  //     'Home',
  //     'service',
  //     'service-advertisementManagement',
  //     'service-advertisementManagement-add'
  //   ],
  //   parent: '',
  //   showTab: false
  // },
  // {
  //   name: '編輯廣告',
  //   route: 'service-advertisementManagement-id',
  //   path: '/service/advertisementManagement/:id',
  //   file: 'service/advertisementManagement/edit',
  //   breadcrumb: [
  //     'Home',
  //     'service',
  //     'service-advertisementManagement',
  //     'service-advertisementManagement-id'
  //   ],
  //   parent: '',
  //   showTab: false
  // },
  {
    name: '社區門禁管理',
    route: 'accessControl',
    path: '/accessControl',
    redirect: '/accessControl/device',
    breadcrumb: ['Home', 'accessControl'],
    showTab: false
  },
  {
    name: '設備列表',
    route: 'accessControl-device',
    path: '/accessControl/device',
    breadcrumb: ['Home', 'accessControl', 'accessControl-device'],
    parent: 'accessControl',
    showTab: true
  },
  {
    name: '設備資訊',
    route: 'accessControl-device-edit',
    path: 'accessControl-device/edit/:id',
    file: 'accessControl/device/edit',
    breadcrumb: [
      'Home',
      'accessControl',
      'accessControl-device',
      'accessControl-device-edit'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '平面圖',
    route: 'accessControl-floorPlan',
    path: '/accessControl/floorPlan',
    breadcrumb: ['Home', 'accessControl', 'accessControl-floorPlan'],
    parent: 'accessControl',
    showTab: true
  },
  {
    name: '卡片管理',
    route: 'accessControl-cardManagement',
    path: '/accessControl/cardManagement',
    breadcrumb: ['Home', 'accessControl', 'accessControl-cardManagement'],
    parent: 'accessControl',
    showTab: true
  },
  {
    name: '新增卡片',
    route: 'accessControl-cardManagement-add',
    path: '/accessControl/cardManagement/add',
    file: 'accessControl/cardManagement/edit',
    breadcrumb: [
      'Home',
      'accessControl',
      'accessControl-cardManagement',
      'accessControl-cardManagement-add'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '編輯卡片',
    route: 'accessControl-cardManagement-edit',
    path: '/accessControl/cardManagement/:id',
    file: 'accessControl/cardManagement/edit',
    breadcrumb: [
      'Home',
      'accessControl',
      'accessControl-cardManagement',
      'accessControl-cardManagement-edit'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '門禁紀錄',
    route: 'accessControl-record',
    path: '/accessControl/record',
    breadcrumb: ['Home', 'accessControl', 'accessControl-record'],
    parent: 'accessControl',
    showTab: true
  },
  {
    name: '卡片操作紀錄',
    route: 'accessControl-operationRecord',
    path: '/accessControl/operationRecord',
    breadcrumb: ['Home', 'accessControl', 'accessControl-operationRecord'],
    parent: 'accessControl',
    showTab: true
  },
  {
    name: '事件告警紀錄',
    route: 'alarm',
    path: '/alarm',
    breadcrumb: ['Home', 'alarm'],
    redirect: '/alarm/index/default',
    showTab: false
  },
  {
    //
    name: '',
    route: 'alarm-index',
    path: '/alarm/index/:range',
    breadcrumb: ['Home', 'alarm'],
    parent: 'alarm',
    showTab: false
  },
  {
    name: '社區住戶管理',
    route: 'resident',
    path: '/resident',
    redirect: '/resident/householdManagement',
    breadcrumb: ['Home', 'resident'],
    showTab: false
  },
  {
    name: '戶別管理',
    route: 'resident-householdManagement',
    path: '/resident/householdManagement',
    breadcrumb: ['Home', 'resident', 'resident-householdManagement'],
    parent: 'resident',
    showTab: true
  },
  {
    name: '新增戶別',
    route: 'resident-householdManagement-add',
    path: '/resident/householdManagement/add',
    file: 'resident/householdManagement/add',
    breadcrumb: [
      'Home',
      'resident',
      'resident-householdManagement',
      'resident-householdManagement-add'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '編輯戶別',
    route: 'resident-householdManagement-edit',
    path: '/resident/householdManagement/:id',
    file: 'resident/householdManagement/edit',
    breadcrumb: [
      'Home',
      'resident',
      'resident-householdManagement',
      'resident-householdManagement-edit'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '戶別資訊',
    route: 'resident-householdManagement-info',
    path: '/resident/householdManagement/:id/info',
    file: 'resident/householdManagement/info',
    breadcrumb: [
      'Home',
      'resident',
      'resident-householdManagement',
      'resident-householdManagement-info'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '車道管理',
    route: 'numberPlate',
    path: '/numberPlate',
    redirect: '/numberPlate/accessRecords',
    breadcrumb: ['Home', 'numberPlate'],
    showTab: false
  },
  // {
  //   name: '車道閘門控制',
  //   route: 'numberPlate-gateControl',
  //   path: '/numberPlate/gateControl',
  //   breadcrumb: ['Home', 'numberPlate', 'numberPlate-gateControl'],
  //   parent: 'numberPlate',
  //   showTab: true
  // },
  // {
  //   name: '車道即時影像',
  //   route: 'numberPlate-realTimeVideo',
  //   path: '/numberPlate/realTimeVideo',
  //   breadcrumb: ['Home', 'numberPlate', 'numberPlate-realTimeVideo'],
  //   parent: 'numberPlate',
  //   showTab: true
  // },
  // {
  //   name: '攝影機資訊編輯',
  //   route: 'numberPlate-realTimeVideo-id',
  //   path: '/numberPlate/realTimeVideo/:id',
  //   file: 'numberPlate/realTimeVideo/edit',
  //   breadcrumb: [
  //     'Home',
  //     'numberPlate',
  //     'numberPlate-realTimeVideo',
  //     'numberPlate-realTimeVideo-id'
  //   ],
  //   showTab: false
  // },
  {
    name: '進出紀錄',
    route: 'numberPlate-accessRecords',
    path: '/numberPlate/accessRecords',
    breadcrumb: ['Home', 'numberPlate', 'numberPlate-accessRecords'],
    parent: 'numberPlate',
    showTab: true
  },
  {
    name: '名單管理',
    route: 'numberPlate-whiteList',
    path: '/numberPlate/whiteList',
    breadcrumb: ['Home', 'numberPlate', 'numberPlate-whiteList'],
    parent: 'numberPlate',
    showTab: true
  },
  {
    name: '新增車輛',
    route: 'numberPlate-whiteList-add',
    path: '/numberPlate/whiteList/add',
    file: 'numberPlate/whiteList/add',
    breadcrumb: [
      'Home',
      'numberPlate',
      'numberPlate-whiteList',
      'numberPlate-whiteList-add'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '編輯車輛',
    route: 'numberPlate-whiteList-edit',
    path: '/numberPlate/whiteList/:id',
    file: 'numberPlate/whiteList/edit',
    breadcrumb: [
      'Home',
      'numberPlate',
      'numberPlate-whiteList',
      'numberPlate-whiteList-edit'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '設備應用管理',
    route: 'deviceApplication',
    path: '/deviceApplication',
    redirect: '/deviceApplication/management',
    breadcrumb: ['Home', 'deviceApplication'],
    showTab: false
  },
  {
    name: '設備管理',
    route: 'deviceApplication-management',
    path: '/deviceApplication/management',
    keepalive: 'DeviceApplicationManagement',
    breadcrumb: ['Home', 'deviceApplication', 'deviceApplication-management'],
    parent: 'deviceApplication',
    showTab: true
  },
  {
    name: '自動化及告警設定',
    route: 'deviceApplication-automation',
    path: '/deviceApplication/automation',
    keepalive: 'DeviceApplicationAutomation',
    breadcrumb: ['Home', 'deviceApplication', 'deviceApplication-automation'],
    parent: 'deviceApplication',
    showTab: true
  },
  {
    // 新增自動化及告警設定
    name: '新增',
    route: 'deviceApplication-automation-add',
    path: '/deviceApplication/automation/add',
    file: 'deviceApplication/automation/edit',
    breadcrumb: [
      'Home',
      'deviceApplication',
      'deviceApplication-automation',
      'deviceApplication-automation-add'
    ],
    parent: '',
    showTab: false
  },
  {
    // 編輯自動化及告警設定
    name: '編輯',
    route: 'deviceApplication-automation-id',
    path: '/deviceApplication/automation/:id',
    file: 'deviceApplication/automation/edit',
    breadcrumb: [
      'Home',
      'deviceApplication',
      'deviceApplication-automation',
      'deviceApplication-automation-id'
    ],
    parent: '',
    showTab: false
  },
  {
    name: '排程紀錄',
    route: 'deviceApplication-schedule',
    path: '/deviceApplication/schedule',
    keepalive: 'DeviceApplicationSchedule',
    breadcrumb: ['Home', 'deviceApplication', 'deviceApplication-schedule'],
    parent: 'deviceApplication',
    showTab: true
  },
  {
    name: '系統管理',
    route: 'system',
    path: '/system',
    redirect: '/system/account',
    breadcrumb: ['Home', 'system'],
    showTab: false
  },
  {
    name: '帳號列表',
    route: 'system-account',
    path: '/system/account',
    breadcrumb: ['Home', 'system', 'system-account'],
    parent: 'system',
    showTab: true
  },
  {
    name: '新增帳號',
    route: 'system-account-add',
    path: '/system/account/add',
    file: 'system/account/operate',
    breadcrumb: ['Home', 'system', 'system-account', 'system-account-add'],
    parent: '',
    showTab: false
  },
  {
    name: '編輯帳號',
    route: 'system-account-id',
    path: '/system/account/:id/:acc',
    file: 'system/account/operate',
    breadcrumb: ['Home', 'system', 'system-account', 'system-account-id'],
    parent: '',
    showTab: false
  },
  {
    name: '角色列表',
    route: 'system-role',
    path: '/system/role',
    breadcrumb: ['Home', 'system', 'system-role'],
    parent: 'system',
    showTab: true,
    disabled: false
  },
  {
    name: '操作紀錄',
    route: 'system-operate',
    path: '/system/operate',
    breadcrumb: ['Home', 'system', 'system-operate'],
    parent: 'system',
    showTab: true,
    disabled: false
  },
  {
    name: '場域設定',
    route: 'system-field',
    path: '/system/field',
    breadcrumb: ['Home', 'system', 'system-field'],
    parent: 'system',
    showTab: true,
    disabled: false
  },
  {
    name: '新增平面圖',
    route: 'system-field-add-img',
    path: '/system/field/addImg',
    file: 'system/field/addImg',
    breadcrumb: ['Home', 'system', 'system-field', 'system-field-add-img'],
    parent: '',
    showTab: false
  },
  {
    name: '編輯平面圖',
    route: 'system-field-edit-img',
    path: '/system/field/editImg/:id',
    file: 'system/field/editImg',
    breadcrumb: ['Home', 'system', 'system-field', 'system-field-edit-img'],
    parent: '',
    showTab: false
  },
  {
    name: '新增',
    route: 'system-field-add',
    path: '/system/field/add',
    file: 'system/field/operate',
    breadcrumb: ['Home', 'system', 'system-field', 'system-field-add'],
    parent: '',
    showTab: false
  },
  {
    name: '編輯',
    route: 'system-field-id',
    path: '/system/field/:buildingId/:floorId',
    file: 'system/field/operate',
    breadcrumb: ['Home', 'system', 'system-field', 'system-field-id'],
    parent: '',
    showTab: false
  },
  {
    name: '社區影像管理',
    route: 'video',
    path: '/video',
    redirect: '/video/liveView',
    breadcrumb: ['Home', 'video'],
    showTab: false
  },
  {
    name: '即時影像',
    route: 'video-liveView',
    path: '/video/liveView',
    breadcrumb: ['Home', 'video', 'video-liveView'],
    parent: 'video',
    showTab: true
  },
  {
    name: '攝影機管理',
    route: 'video-channelManagement',
    path: '/video/channelManagement',
    breadcrumb: ['Home', 'video', 'video-channelManagement'],
    parent: 'video',
    showTab: true
  },
  {
    name: '下載影像',
    route: 'video-record',
    path: '/video/record',
    breadcrumb: ['Home', 'video', 'video-record'],
    parent: 'video',
    showTab: true
  },
  {
    name: '常見使用問題說明',
    route: 'IEModeInfo',
    path: '/IEModeInfo',
    file: 'IEModeInfo',
    breadcrumb: ['Home', 'IEModeInfo'],
    parent: '',
    showTab: false
  }
]
